import React, { Component } from 'react'
import '../styles/GiftCardPlayerCard.css'
import { injectIntl, defineMessages } from 'react-intl'

class GiftCardPlayerCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      numberOfPlayers: null
    }
  }

  giftCardPlayerStyle = selected => {
    if (selected) {
      return "gift-card-player-card gift-card-player-card--selected"
    } else {
      return "gift-card-player-card"
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props

    return (
     <div
       className={this.giftCardPlayerStyle(this.props.selected)}
       onClick={() => this.props.handlePlayerSelect(this.props.numberOfPlayers)}>
       <div className="gift-card-player-info">
         <p>{formatMessage(messages.giftCard)}</p>
         <p>{this.props.numberOfPlayers == 1 ? formatMessage(messages.voucher) : this.props.numberOfPlayers + ' ' + formatMessage(messages.players)}</p>
         <p>{this.props.price} €</p>
       </div>
       <div className="gift-card-player-validation">
         <span className="gift-card-player-validation-circle"><i className="fas fa-check"></i></span>
       </div>
     </div>
    )
  }
}

const messages = defineMessages({
  giftCard: {
    id: 'gc.giftCard',
    defaultMessage: "Carte Cadeaux"
  },
  players: {
    id: 'gc.players',
    defaultMessage: "joueurs"
  },
  voucher: {
    id: 'gc.voucher',
    defaultMessage: "bon achat"
  }

})

export default injectIntl(GiftCardPlayerCard)



// WEBPACK FOOTER //
// ./src/components/GiftCardPlayerCard.js